import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class StateService {
  saveState<T = any>(key: string, state: T): void {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch (e) {
      console.warn('Failed to save state', e);
    }
  }

  loadState<T = any>(key: string): T | null {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw) as T;
    } catch (e) {
      console.warn('Failed to load state', e);
      return null;
    }
  }

  removeState(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      // ignore
    }
  }
}
